import { Grid, styled } from '@material-ui/core';

export const Wrapper = styled(Grid)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.grey['50'],
}));
